import { create } from 'zustand';
import type { User } from '@/services/api';
import { isImpersonating, impersonatedEmail, startImpersonation, restoreAdminSession } from '@/lib/impersonation';

interface ImpersonationState {
  isImpersonating: boolean;
  impersonatedEmail: string;
  start: (token: string, user: User) => void;
  stop: () => void;
}

// State is seeded from localStorage because start()/stop() reload the page so the app
// re-reads the active identity from storage on the next load.
export const useImpersonationStore = create<ImpersonationState>(() => ({
  isImpersonating: isImpersonating(),
  impersonatedEmail: impersonatedEmail(),
  start: (token, user) => {
    startImpersonation(token, { id: user.id, email: user.email });
    window.location.assign('/account');
  },
  stop: () => {
    restoreAdminSession();
    window.location.assign('/admin/users');
  },
}));
